import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {MessageService} from "../../../core/services/message.service";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {ArquivoService} from "../../../services/arquivo.service";

@Component({
    selector: 'app-dialog-texto-anexo',
    templateUrl: './dialog-texto-anexo.component.html',
    styleUrls: ['./dialog-texto-anexo.component.scss']
})
export class DialogTextoAnexoComponent implements OnInit {

    public texto: string;
    public cod_arquivo: string;
    public mostrar_botao_voltar: boolean = false;
    public form: FormGroup;
    public arquivos: Array<any> = [];

    constructor(public dialogRef: MatDialogRef<DialogTextoAnexoComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private messageService: MessageService, private arquivoService: ArquivoService) {

    }

    ngOnInit() {
        this.dialogRef.disableClose = true;
        this.mostrar_botao_voltar = true;
        this.texto = this.data.texto;
        this.cod_arquivo = this.data.cod_arquivo;
        this.form = new FormGroup({});
        this.form = new FormGroup({
            texto: new FormControl(this.texto),
            cod_arquivo: new FormControl(this.cod_arquivo),
        });
    }

    close(arquivo: Array<any>): void {
        this.dialogRef.close({arquivos: this.arquivos});
    }

    save(): void {
        let form: any = this.form.value;
        let form_invalido: boolean = false;
        if (this.form.valid) {
            this.arquivoService.alteraDescricao(form).subscribe(data => {
                this.arquivos =  data.files;
                this.messageService.showSuccess("Descrição alterada com sucesso!");
            });

            if (form_invalido) {
                this.messageService.showError("Preencha os campos obrigatórios");
            }else{
                this.close(this.arquivos);
            }
        }
    }

}
